module.exports = __webpack_public_path__ + "img/machine-picture-exemple.297d3560.jpg";